import {
  GEOGRAPHY_PAGE_TAB_IDENTIFIERS,
  MUNICIPALITY_FEATURES,
  type GeographyPageFeatures,
  type MunicipalityFeatures,
} from '@schema/featureToggle'
import { municipalityTabs } from './constants'

const geographyPageTabValues = new Set<string>(
  Object.values(GEOGRAPHY_PAGE_TAB_IDENTIFIERS),
)

const municipalityFeatureValues = new Set<string>(
  Object.values(MUNICIPALITY_FEATURES),
)

export const isMunicipalityFeature = (
  tab: GeographyPageFeatures,
): tab is MunicipalityFeatures => municipalityFeatureValues.has(tab)

export const resolveMunicipalityPageTab = (
  tab: GeographyPageFeatures,
): MunicipalityFeatures =>
  isMunicipalityFeature(tab) ? tab : MUNICIPALITY_FEATURES.overview

/** Municipality tab keys mapped to localized URL path segments */
const municipalityPageTabUrlSegmentByTab: Partial<
  Record<MunicipalityFeatures, string>
> = {
  [municipalityTabs.current]: 'actueel',
  [municipalityTabs.discussion]: 'discussie',
  [municipalityTabs.initiatives]: 'initiatieven',
  [municipalityTabs.locations]: 'locaties',
  [municipalityTabs.knowledgeHub]: 'kennishub',
  [municipalityTabs.stepByStep]: 'stappenplan',
}

const municipalityPageTabByUrlSegment = Object.fromEntries(
  Object.entries(municipalityPageTabUrlSegmentByTab).map(([tab, segment]) => [
    segment,
    tab,
  ]),
) as Record<string, MunicipalityFeatures>

export const municipalityPageTabToUrlSegment = (tab: string): string =>
  municipalityPageTabUrlSegmentByTab[tab as MunicipalityFeatures] ?? tab

export const parseMunicipalityPageTab = (
  tab: string | undefined | null,
): GeographyPageFeatures => {
  if (tab && municipalityPageTabByUrlSegment[tab]) {
    return municipalityPageTabByUrlSegment[tab]
  }
  if (tab && geographyPageTabValues.has(tab)) {
    return tab as GeographyPageFeatures
  }
  return GEOGRAPHY_PAGE_TAB_IDENTIFIERS.overview
}
